import React from "react";

import Header from "../../components/skinefit/Header";
import Banner from "../../components/skinefit/Banner";
import Footer from "../../components/skinefit/Footer";
import Products from "../../components/skinefit/Products";
import Hero from "../../components/skinefit/Hero";
import ProductList from "../../components/skinefit/ProductList";
// import productImg1 from '../../assets/images/skinefit/img1.jpg'

const HomePage = () => {
  return (
    <div className="overflow-x-hidden bg-[#f5eae6]">
      <Header />

      <Hero />

      {/* <div className="">
        <h1 className="text-2xl font-extralight text-center leading-8 tracking-widest mb-5">
          ESSENTIAL <br /> CARE FOR SKIN
        </h1>
        <CardSlider skincareData={products} />
      </div> */}

      <Products />

      <Banner />
      <ProductList />
      <Footer />
    </div>
  );
};

export default HomePage;
